'use client'

import {useApp} from 'AppContext'
import {Footer} from 'layout/partials/footer/footer'
import {Theme} from 'layout/theme'
import React from 'react'
import {fromModule} from 'util/styler/Styler'
import css from './layout.module.scss'
import {Header} from './partials/header/header'

const styles = fromModule(css)

export const Layout: React.FC<{children: React.ReactNode}> = ({children}) => {
	const {general} = useApp()
	const projectKey = process.env.NEXT_PUBLIC_PROJECT_KEY

	return (
		<div className={styles.layout()} data-project={projectKey}>
			<Header items={general?.menu} />
			<span id="scroll" />
			<Theme.OuterContainer>
				<div className={styles.layout.content()}>{children}</div>
			</Theme.OuterContainer>
			<Footer {...general?.footer} />
		</div>
	)
}
